import styled from 'styled-components';

import { Box } from '@sternum/styled-system';
import { IconButton } from '@sternum/ui';

export const CodeContainer = styled(Box)`
  position: relative;
  overflow: auto;
  width: 100%;
`;

export const CopyIconButton = styled(IconButton)`
  position: absolute;
  right: 12px;
  top: 12px;
`;
